import React, { memo } from 'react';

import { ErrorMessage } from '@/shared/components/ErrorMessage';

import {
  InputComponent,
  InputLabel,
  InputWrapper,
  OptInfo,
  PartWithOptInfo,
  Required,
} from './parts';
import type { IProps } from './types';

const Input: React.FC<IProps> = ({
  label,
  register,
  id,
  defaultValue = '',
  placeholder = '',
  className = 'Input',
  externalRules,
  error,
  optInfo,
  tooltipButton,
  isShowRequiredSign = true,
  isErrorAsInfoMessages,
  tabIndex,
  autoComplete,
}) => {
  const errorId = `${id}-error`;
  const isRequired =
    (typeof externalRules?.required === 'boolean' && externalRules?.required) ||
    externalRules?.required?.value;

  return (
    <InputWrapper className={className}>
      <InputLabel
        htmlFor={id}
        className="InputLabel"
        {...(!!error && {
          'aria-describedby': errorId,
        })}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />{' '}
        {tooltipButton}
        {isRequired && isShowRequiredSign && <Required />}
      </InputLabel>
      <PartWithOptInfo>
        <InputComponent
          {...(register && register(id, { ...externalRules, value: defaultValue }))}
          className="InputComponent"
          type="text"
          defaultValue={defaultValue}
          placeholder={placeholder}
          aria-required={isRequired}
          id={id}
          aria-label={label}
          aria-invalid={!!error}
          tabIndex={tabIndex}
          {...(!!error && {
            'aria-describedby': errorId,
          })}
          autoComplete={autoComplete}
        />
        <ErrorMessage error={error} isInfo={isErrorAsInfoMessages} id={errorId} />
        {optInfo && <OptInfo>{optInfo}</OptInfo>}
      </PartWithOptInfo>
    </InputWrapper>
  );
};

export default memo(Input);
